import React from 'react'
import { useState, useEffect } from 'react'
import { useFirestoreGeneralOrderBy } from '../../firebase/useFirestore'
import LiveReportMedia from './LiveReportMedia'
import deleteIcon from '../../images/icons/delete-icon.png'
import { db } from '../../firebase/config'
import Tooltip from '../common/Tooltip'
import LiveReportResearchData from './LiveReportResearchData'
import firebase from '../../firebase/compat'
import ReadOnlyGuard from '../common/ReadOnlyGuard'

const ReportBuilderResearch = ({researchId, docid, startDate, endDate}) => {

    // Firestore
    const research = useFirestoreGeneralOrderBy('Research', 'ID', researchId ? researchId : '', 'Position', 'asc')

    const questionnaireId = research?.[0]?.QuestionnaireID || '';

    // Add description to research
    const researchDescriptionHandler = (e) => {
        const docid = e.target.dataset.docid

        db.collection('Research')
        .doc(docid)
        .update({
            Description: e.target.value
        })
    }

    // Delete research
    const deleteResearch = (e) => {
        const id = e.currentTarget.dataset.id

        db.collection('LiveReports')
        .doc(docid)
        .update({
            Researches: firebase.firestore.FieldValue.arrayRemove(id)
        })


    }

  return (
    <ReadOnlyGuard edit="reports.edit">
        {(canEdit) => (
            <div className="report-activities-container">
                {research && research.map(item => (
                    <div key={item.ID} className="report-activity-item-container" style={{borderBottom: research.length === 1 ? 'none' : '1px solid lightgray'}}>
                        <div className="report-activity-item-description-container">
                            <h3>{item.Title}</h3>
                            <textarea cols="30" data-docid={item.docid} defaultValue={item.Description} placeholder="Voeg een omschrijving toe van de activiteit" rows="10" onChange={researchDescriptionHandler}></textarea>
                            <LiveReportMedia parent={item}/>
                        </div>
                        <div className="report-activity-item-graph-container">
                            <h3>Resultaten uit onderzoek</h3>
                            <LiveReportResearchData
                            questionnaireId={questionnaireId}
                            researchId={item.ID}
                            startDate={startDate}
                            endDate={endDate}/>
                        </div>
                        {canEdit && (
                            <Tooltip content="Effect verwijderen" width='4%' top='-60px'>
                                <img className="delete-icon-report-builder" src={deleteIcon} alt="" data-id={item.ID} onClick={deleteResearch}/>
                            </Tooltip>
                        )}
                    </div>
                ))}
            </div>
        )}
    </ReadOnlyGuard>
  )
}

export default ReportBuilderResearch